import Vue from 'vue';

export class Cliente {

    static create () {

        let street = {};

        street.nome = '';
        street.email = '';
        street.cidade = '';
        street.estado = '';
        street.bairro = '';
        street.endereco = '';
        street.complemento = '';
        street.telefone1 = '';
        street.telefone2 = '';
        street.celular = '';
        street.whatsapp_cobranca = '';
        street.fax = '';
        street.cep = '';
        street.tipo_cliente = 'f';
        street.obs = '';
        street.tipo_cliente = 'F';
        street.telefones = [];
        street.razao_social = '';
        street.habilitar_bloqueio = false;
        street.telemetria = false;
        street.numero = '';
        street.rg_ie = '';
        street.cpf_cnpj = '';
        street.id_parceiro = null;
        street.periodo_pagamento = 'MENSAL';
        return street;
    }

    /**
     *
     * @param json
     * @returns {Promise}
     */
    static save (json) {
        return new Promise((ok, fail) => {

            let promise = null;

            if (json.uuid) {
                promise = Vue.http.put('clientes/'+ json.uuid, json);
            } else {
                promise = Vue.http.post('clientes', json);
            }

            promise.then((res) => ok(res.data)).catch((err) => fail(err));

        });
    }

    /**
     * Atualiza os valores básicos mensais de múltiplos veículos
     * @param {Array} updates - Array de objetos com {id_rastreador, basico_mensal}
     * @returns {Promise}
     */
    static updateBasicMonthlyValue(id_cliente, value){
        return new Promise((ok, fail) => {
            Vue.http.patch('v1/clientes/update-basic-monthly-value/veiculos', {
                id_cliente: id_cliente,
                value: value
            })
            .then((res) => ok(res.data))
            .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param uuid
     * @returns {Promise}
     */
    static bloqueia (uuid) {
        return Vue.http.post('clientes/bloqueio-financeiro/'+ uuid, {});
    }

    /**
     *
     * @param uuid
     * @returns {Promise}
     */
    static desbloqueia (uuid) {
        return Vue.http.delete('clientes/bloqueio-financeiro/'+ uuid);
    }

    static saveTelefones (uuid, json) {
        return Vue.http.put('clientes/'+ uuid + '/telefones', {
            telefones: json
        });
    }

    static prognosticoFinanceiro () {
        return Vue.http.get('v1/clientes/prognostico');
    }

    static refreshToken (uuid) {
        return Vue.http.get('clientes/' + uuid + '/gerar-token');
    }

    static sendPush (uuid, json) {
        return Vue.http.post('clientes/' + uuid + '/send-push', json);
    }

    static sendPushAll (json) {
        return Vue.http.post('v1/clientes/send-push/all', json);
    }

    /**
     *
     * @param cep
     * @returns {Promise}
     */
    static getCep (cep) {
        return new Promise((ok, fail) => {

            Vue.http.get('https://cep.centeralarm.com.br/cep/' + cep)
                .then((res) => {
                    ok(res.data);
                })
                .catch((err) => {
                    fail(err);
                });

        });
    }

    /**
     *
     * @param uuid
     * @return {Promise}
     */
    static byPK (uuid) {
        return new Promise((ok, fail) => {
            Vue.http.get('clientes/'+ uuid)
                .then((res) => {
                    ok(res.data);
                })
                .catch((err) => {
                    fail(err);
                });
        });
    }

    /**
     *
     * @param id
     * @return {Promise}
     */
    static byPKId (id) {
        return new Promise((ok, fail) => {
            Vue.http.get('clientes/by-pk/'+ id)
                .then((res) => {
                    ok(res.data);
                })
                .catch((err) => {
                    fail(err);
                });
        });
    }

    /**
     *
     * @param uuid
     * @param path
     * @return {Promise}
     */
    static relatorio (uuid, path = '/#/relatorio/periodo') {
        return new Promise((resolve, reject) => {
            let param = {
                path
            };
            Vue.http.post('view/'+ uuid + '/relatorios', param)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    /**
     *
     * @param nome
     * @return {Promise}
     */
    static byNome (nome) {
        return new Promise((ok, fail) => {
            Vue.http.get('clientes/by-nome/'+ nome)
                .then((res) => ok(res.data.clientes))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param usuario
     * @return {Promise}
     */
    static byUsuario (usuario) {
        return new Promise((ok, fail) => {
            Vue.http.get('logins/by-usuario/'+ usuario)
                .then((res) => ok(res.data[0]))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param uuid
     * @return {Promise}
     */
    static getLoginPorta (uuid) {
        return new Promise((ok, fail) => {
            Vue.http.get('clientes/' + uuid + '/usuarios')
                .then((res) =>  ok(res.data.usuarios))
                .catch((err) => fail(err));
        });
    }

    static getIbuttons (uuid) {
        return new Promise((ok, fail) => {
            Vue.http.get('clientes/' + uuid + '/ibuttons')
                .then((res) =>  ok(res.data.ibuttons))
                .catch((err) => fail(err));
        });
    }

    static getgrupos (uuid) {
        return new Promise((ok, fail) => {
            Vue.http.get('clientes/' + uuid + '/grupos')
                .then((res) =>  ok(res.data.ibuttons))
                .catch((err) => fail(err));
        });
    }

    static getNotas (uuid) {
        return new Promise((ok, fail) => {
            Vue.http.get('v1/clientes/' + uuid + '/notas-fiscais')
                .then((res) =>  ok(res.data.notas))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param id_login_site
     * @return {Promise}
     */
    static getLogin (id_login_site) {
        return new Promise((ok, fail) => {
            Vue.http.get('login/' + id_login_site)
                .then((res) =>  ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param json
     * @returns {Promise<any>}
     */
    static putLogin (json) {
        return new Promise((ok, fail) => {
            Vue.http.put('login/' + json.id_login_site, json)
                .then((res) =>  ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param json
     * @returns {Promise<any>}
     */
    static putLoginTelegram (json) {
        return new Promise((ok, fail) => {
            Vue.http.put('login/' + json.id_login_site + '/telegram', json)
                .then((res) =>  ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param uuid
     * @return {Promise}
     */
    static rebootSenha (uuid) {
        return Vue.http.put('clientes/reboot-senha/'+ uuid, { uuid });
    }

    /**
     *
     * @param uuid
     * @return {Promise}
     */
    static remove (uuid) {
        return Vue.http.delete('clientes/'+ uuid);
    }

    /**
     *
     * @return {Promise}
     */
    static grid () {
        return Vue.http.get('grid/clientes');
    }

    static gridMobile () {
        return Vue.http.get('grid/clientes/mobile');
    }

    static gridV2 () {
        return Vue.http.get('grid/clientes/v2');
    }

    /**
     *
     * @return {Promise}
     */
    static grid30Dias () {
        return Vue.http.get('grid/clientes/30dias');
    }

}
